import { HttpError, LogicalFilter } from "@refinedev/core";
import { UseTableReturnType } from "@refinedev/react-table";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const ALL = "all";

/**
 * Action-bar quick filters for the shelves list: section and quick-action.
 *
 * These write the same Refine filter state (`section` / `isQuickAction`, eq)
 * that the column-header "select" filters use, so the two stay in sync and the
 * action bar's "Clear Filters" button resets them too.
 */
export function ShelvesQuickFilters({
  table,
}: {
  table: UseTableReturnType<any, HttpError>;
}) {
  const filters = table.refineCore.filters as LogicalFilter[];

  const current = (field: string) =>
    (filters.find((f) => f.field === field && f.operator === "eq")?.value as
      | string
      | undefined) ?? ALL;

  const apply = (field: string, value: string) => {
    if (value === ALL) {
      table.refineCore.setFilters((prev) =>
        prev.filter((f) => (f as LogicalFilter).field !== field),
      );
    } else {
      table.refineCore.setFilters([{ field, operator: "eq", value }], "merge");
    }
  };

  return (
    <div className="flex items-center gap-1">
      <Select
        value={current("section")}
        onValueChange={(v) => apply("section", v)}
      >
        <SelectTrigger className="h-9 w-[140px]">
          <SelectValue placeholder="Section" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL}>All sections</SelectItem>
          <SelectItem value="Music">Music</SelectItem>
          <SelectItem value="Cinema">Cinema</SelectItem>
          <SelectItem value="Theater">Theater</SelectItem>
        </SelectContent>
      </Select>

      <Select
        value={current("isQuickAction")}
        onValueChange={(v) => apply("isQuickAction", v)}
      >
        <SelectTrigger className="h-9 w-[150px]">
          <SelectValue placeholder="Quick action" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL}>All shelves</SelectItem>
          <SelectItem value="true">Quick actions</SelectItem>
          <SelectItem value="false">Regular</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
